var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#currency_svg__clip0_61530_7412)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 9V7.5h-3V5.25h-1.5V7.5h-1.5A1.502 1.502 0 008.25 9v2.25a1.501 1.501 0 001.5 1.5h4.5V15h-6v1.5h3v2.25h1.5V16.5h1.5a1.502 1.502 0 001.5-1.5v-2.25a1.502 1.502 0 00-1.5-1.5h-4.5V9h6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 11-9 9 9.027 9.027 0 019-9zm0-1.5A10.5 10.5 0 1022.5 12 10.53 10.53 0 0012 1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "currency_svg__clip0_61530_7412"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCurrency;